// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1toi_","checkboxCol":"Table_checkboxCol__1EpRB","emailCol":"Table_emailCol__vSCiX","actionCol":"Table_actionCol__Q9F16"};